export default "__VITE_ASSET__DPQ6JuFJ__"